<template>
    <div id="app">
        <router-view></router-view>
        <div class="fixed-return" @click="goBack"><img src="./images/bank.png" alt="" /></div>
    </div>
</template>

<script>
export default {
    beforeCreate() {
        document.querySelector('body').setAttribute('style', 'margin: 0px;');
    },
    methods: {
        // 返回上一页
        goBack() {
            if (this.$route.meta.rePath) {
                this.$router.push({ path: this.$route.meta.rePath, query: { phone: this.$root.$globalData.phone1 } });
            } else if (this.$route.meta.backPath) {
                window.location.href = 'https://h5.pzhszgh.cn/welfare';
            } else {
                this.$router.go(-1);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
* {
    padding: 0;
    margin: 0;
}
.fixed-return {
    position: fixed;
    bottom: 20%;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    // background: #ff6633;
    z-index: 999;
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    user-select: none;
    img {
        width: 40px;
        height: 40px;
    }
}

::v-deep {
    .el-pagination.is-background .el-pager li:not(.disabled) {
        background-color: #fff; // 进行修改未选中背景和字体
        // color: #fff;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #c40210; // 进行修改选中项背景和字体
        color: #fff;
    }
    .el-pagination button,
    .el-pagination span:not([class*='suffix']) {
        display: inline-block;
        font-size: 16px;
        min-width: 35.5px;
        height: 32px;
        width: 84px;
        line-height: 32px;
        vertical-align: top;
        box-sizing: border-box;
    }

    .el-message {
        font-size: 30px;
    }
}
</style>
